
export const getters = {
    getContaReceber: state => state.contaReceber,
    getContasReceber: state => state.contasReceber,
    getModalCadastroContaReceber: state => state.modalCadastrarContaReceber,
    getModalBaixaContaReceber: state => state.modalBaixaContaReceber,
    getModalExcluirContaReceber: state => state.modalExcluirContaReceber,
    getModalPesquisarContaReceber: state => state.modalPesquisarContaReceber,
    getContaReceberSituacoes: state => state.contaReceberSituacoes,
    getContaReceberPortadores: state => state.contaReceberPortadores,
    getContaReceberFormasPagamento: state => state.contaReceberFormasPagamento,
    getContaReceberOcorrenciaTipos: state => state.contaReceberOcorrenciaTipos,
    getContaReceberOcorrencias: state => state.contaReceberOcorrencias,
    getShowInputAnexoContaReceber: state => state.showInputAnexoContaReceber,
    getModalReciboTotalContaReceber: state => state.modalReciboTotalContaReceber,
    getModalReciboParcialContaReceber: state => state.modalReciboParcialContaReceber,
    getMovimentacaoExtratoContaReceber: state => state.movimentacaoExtratoContaReceber,
}

export default {}